// Utility helpers related to files & mime types
export const iconClassByMime = (mime = "") => {
    const t = mime.toLowerCase();
    if (t.startsWith("image/")) return "bi-file-earmark-image";
    if (t === "application/pdf") return "bi-file-earmark-pdf";
    if (t.includes("spreadsheet") || t === "text/csv") return "bi-file-earmark-spreadsheet";
    return "bi-file-earmark";
};
